// Form controls — calm surface + hairline that lifts to brand on focus (focus
// ring in primitives.css). Field wraps a labelled control; Input/Textarea/Select
// are the raw controls. Every control clears a 44px+ touch target.
export function Field({ label, htmlFor, className = "", style, children }) {
  return (
    <div className={`bz-field ${className}`.trim()} style={style}>
      {label && <label className="bz-field__label" htmlFor={htmlFor}>{label}</label>}
      {children}
    </div>
  );
}

export function Input({ className = "", ...rest }) {
  return <input className={`bz-input ${className}`.trim()} {...rest} />;
}

export function Textarea({ className = "", ...rest }) {
  return <textarea className={`bz-textarea ${className}`.trim()} {...rest} />;
}

export function Select({ className = "", children, ...rest }) {
  return <select className={`bz-select ${className}`.trim()} {...rest}>{children}</select>;
}
